// extracted by mini-css-extract-plugin
module.exports = {"fixed":"style_fixed__ZMWnj","bottom":"style_bottom__Hs4T3","top":"style_top__k3s2I"};